import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import Vue from 'vue';
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://4a314ed363c740c4be5fb749f4da3e22@o405513.ingest.sentry.io/5271264',
    integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
    environment: process.env.NODE_ENV || 'undefined',
  });
}
